import Vue, { DirectiveOptions, DirectiveFunction, VNode } from 'vue'
import { DirectiveBinding } from 'vue/types/options'

import { find } from 'lodash'
import { VNodeDirective } from 'vue/types/vnode'

function event(name: string) {
  const evt = document.createEvent('Event')
  evt.initEvent(name, true, true)
  return evt
}

const bind: DirectiveFunction = (
  el: HTMLElement,
  binding: DirectiveBinding,
  vnode: VNode
) => {
  if (el.tagName.toLocaleUpperCase() !== 'TEXTAREA') {
    const els = el.getElementsByTagName('textarea')
    if (els.length !== 1) {
      throw new Error(
        'v-mask directive requires 1 textarea, found ' + els.length
      )
    } else {
      el = els[0]
    }
  }

  let model: VNodeDirective | undefined
  if (vnode.data !== undefined) {
    model = find(vnode.data.directives, (directive: VNodeDirective) => {
      return directive.name === 'model'
    })
  }

  const name = model ? model.expression : ''

  el.oninput = (e: any) => {
    if (!e.isTrusted) return

    let value = e.target.value
    if (binding.value) {
      value = value.replace(/\n/g, '')
    }
    if (name) {
      if (vnode.context !== undefined) {
        Vue.set(vnode.context, name, value)
      }
    } else {
      e.target.value = value
    }

    el.dispatchEvent(event('input'))
  }
}

export const LimitLinefeed: DirectiveOptions = {
  bind
}
